import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { StaticImage, GatsbyImage } from "gatsby-plugin-image"
import useNestedDropdown from "hooks/useNestedDropdown"
import DropdownToggleLink from "reuseable/links/DropdownToggleLink"
import Social from "./social"

const OffCanvas = () => {
  useNestedDropdown()

  const data = useStaticQuery(graphql`
    query {
      wpMenu(name: { eq: "Main" }) {
        id
        menuItems {
          nodes {
            id
            label
            uri
          }
        }
      }
      allWpProject(limit: 11, sort: { date: DESC }) {
        nodes {
          title
          uri
          featuredImage {
            node {
              altText
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    placeholder: DOMINANT_COLOR
                    quality: 80
                  )
                }
              }
            }
          }
        }
      }
    }
  `)

  const navProjects = data.allWpProject.nodes
  const navItems = data.wpMenu.menuItems.nodes

  return (
    <div
      id="offcanvas-nav"
      data-bs-scroll="true"
      className="navbar-collapse offcanvas offcanvas-nav offcanvas-start"
    >
      <div className="offcanvas-header d-lg-none d-flex flex-column text-center position-relative">
        <Link to="/">
          <StaticImage src="../../assets/img/logo-com2com.jpg" />
        </Link>
        <button
          type="button"
          aria-label="Close"
          data-bs-dismiss="offcanvas"
          className="btn-close position-absolute"
          style={{ top: "10px", right: "24px" }}
        />
      </div>

      <div className="offcanvas-body ms-lg-auto d-flex flex-column h-100">
        <ul className="navbar-nav">
          <li className="nav-item dropdown dropdown-mega">
            <DropdownToggleLink
              title="Projects"
              className="nav-link dropdown dropdown-toggle"
            />
            <ul className="dropdown-menu mega-menu mega-menu-img">
              <li className="mega-menu-content">
                <ul className="row row-cols-1 row-cols-lg-6 gx-0 gx-lg-6 gy-lg-4 list-unstyled">
                  <li className="col d-flex  align-items-center ">
                    <Link to="/projects" className="dropdown-item text-center">
                      All projects ...
                    </Link>
                  </li>
                  {navProjects?.map(navProj => (
                    <li className="col" key={navProj.id}>
                      <Link
                        to={navProj.uri}
                        className="dropdown-item"
                        passHref
                        legacyBehavior
                      >
                        <div className="rounded img-svg d-none d-lg-block mb-lg-2">
                          <GatsbyImage
                            image={
                              navProj.featuredImage?.node?.localFile
                                ?.childImageSharp?.gatsbyImageData
                            }
                            alt={navProj.featuredImage?.node?.altText}
                            className="shadow-lg rounded-0 img-fluid"
                          />
                        </div>

                        <div className="">{navProj.title}</div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </li>

          {navItems?.map(navItem => (
            <li className="nav-item" key={navItem.id}>
              <Link to={navItem.uri} className="nav-link">
                {navItem.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="offcanvas-footer mt-6 d-flex justify-content-center d-lg-none">
          <Social />
        </div>
      </div>
    </div>
  )
}

export default OffCanvas
